import Login from "../pages/Login";
import Menu from "../pages/Menu";
import NotFound from "../pages/Not-Found";
import Startup from "../pages/Startup";
import Analytics from "../pages/admin/analytics";
import Dashboard from "../pages/admin/dashboard";
import SuperAdminDashboard from "../pages/admin/super-admin";
import SuperAdminLogin from "../pages/admin/super-admin-login";

export const routes = [
  {
    path: "/",
    element: <Startup />,
    roles: ["user"],
    redirectTo: "/dashboard",
  },
  {
    path: "/login",
    element: <Login />,
    public: true,
    redirectTo: "/",
  },
  {
    path: "/startup",
    element: <Startup />,
    roles: ["user"],
    redirectTo: "/startup",
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    roles: ["admin", "superadmin"],
    providers: ["CurrencyProvider", "CartProvider", "DashboardProvider"],
  },
  {
    path: "/analytics",
    element: <Analytics />,
    roles: ["admin", "superadmin"],
    providers: ["AnalyticsProvider"],
  },
  {
    path: "/menu",
    element: <Menu />,
    roles: ["user"],
    providers: [
      "ActivityProvider",
      "MenuProvider",
      "CurrencyProvider",
      "CartProvider",
    ],
    redirectTo: "/dashboard",
  },
  {
    path: "/super-admin/login",
    element: <SuperAdminLogin />,
    public: true,
    redirectTo: "/super-admin",
  },
  {
    path: "/super-admin",
    element: <SuperAdminDashboard />,
    roles: ["superadmin"],
    redirectTo: "/dashboard",
  },
  // Catch-all route for undefined paths
  {
    path: "*",
    element: <NotFound />,
    public: true, // Public to allow access for any user
  },
  {
    path: "*",
    element: <NotFound />,
    public: false,
  },
];
